const BADGES = ['CMMC LEVEL 2', 'NIST SP 800-171', 'FEDRAMP HIGH INFRASTRUCTURE']

const CONTROLS = [
  {
    title: "Your office's data stays your office's.",
    body: 'CUI handled in a managed enclave. Visible to your office and leadership, never laterally, unless you share it.',
  },
  {
    title: 'You control access.',
    body: 'Role-based permissions by program and portfolio. Immutable audit log of every user and agent action.',
  },
  {
    title: 'Your models, your boundary.',
    body: 'Model-agnostic and containerized. Runs on assured workloads, or the accredited model inside your environment.',
  },
]

export default function Trust() {
  return (
    <section id="trust" className="lp-sec">
      <div className="lp-wrap lp-two">
        <div style={{ minWidth: 0 }}>
          <h2 className="lp-h2" style={{ marginBottom: 20 }}>
            Your data. Your control.
          </h2>
          <div className="lp-badges">
            {BADGES.map((b) => (
              <span key={b}>{b}</span>
            ))}
          </div>
        </div>

        <div className="lp-controls">
          {CONTROLS.map((c) => (
            <div key={c.title}>
              <h3>{c.title}</h3>
              <p>{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
